import React from 'react';
import styled from 'styled-components';

interface ContentSectionProps {
  children: any;
}

const ContentSection: React.FC<ContentSectionProps> = ({ children }) => {
  return (
    <Main id="msp-main" tabIndex={-1}>
      {children}
    </Main>
  );
};

export default ContentSection;

const Main = styled.main`
  max-width: 1400px;
  margin: 0 auto;
  padding: 80px 0 120px 0;
  position: relative;
`;
